import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AuthService from 'services/auth'
import BusinessNavbar from 'components/Navbars/BusinessNavbar'
import RatingList from 'components/Lists/RatingList'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container, Title } from '../styles'

export default function ProfessionalRatings () {
  const location = useLocation ()
  const [loading, setLoading] = useState (true)
  const [professionalRatings, setProfessionalRatings] = useState ([])
  const { professional } = location.state
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getBusinesses ()
  }, [])

  const getBusinesses = async () => {
    try {
      setLoading (true)
      const { data: professionalRatings } = await cutileiApi.get (
        `/professionals/${professional.id}/ratings?business_id=${businessId}`, requestConfig
      )
      setProfessionalRatings (professionalRatings)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  return (
    <Container>
      <BusinessNavbar/>
      <Title>
        Avaliações de {professional.nickname}
      </Title>
      {loading ? <Loading/> : (
        <RatingList ratings={professionalRatings}/>
      )}
    </Container>
  )
}
